// 지도에서 쓰는 설정 상수들
// 지도관제 외에도 지도가 있는 곳들에서 참조하면 됨
/** 라인 관련 */
export const strokeConfig = {
    /** 일반 라인 */
    NORMAL: {
        strokeColor: '#00A7FF',
        strokeWeight: 4,
        strokeOpacity: 0.8,
        strokeLineCap: 'round',
    },
    DROP: {
        strokeColor: '#00A7FF',
        strokeWeight: 4,
        strokeOpacity: 0.8,
        strokeLineCap: 'round',
    },
    /** 픽업상태 */
    PICKUP: {
        strokeColor: '#6D4C41',
        strokeWeight: 4,
        strokeOpacity: 0.8,
        strokeLineCap: 'round',
    },
};
